import {
    Component,
    OnInit,
    ViewEncapsulation,
    Input,
    ChangeDetectorRef,
    AfterViewChecked,
    Injector,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UntypedFormBuilder, UntypedFormArray } from '@angular/forms';
import { DropdownsService } from 'app/services';
import { TranslateService } from '@ngx-translate/core';
import { OwnersCreateComponent } from '../../owners-create.component';
import { isEmpty } from 'lodash';
import { debounceTime, distinctUntilChanged, startWith, switchMap, tap } from 'rxjs/operators';
import { merge } from 'rxjs';
import { isMoment } from 'moment';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
    selector: 'tab-id',
    templateUrl: './tab-id.component.html',
    styleUrls: ['./tab-id.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TabIdComponent implements OnInit, AfterViewChecked {
    @Input() form: UntypedFormGroup;
    partners: UntypedFormArray;
    countries: any;
    systemlang: string;
    _ownersCreateComponent: OwnersCreateComponent;
    classifications: any;
    currentRoute: 'owner';
    public linkedUsersSearch: UntypedFormControl = new UntypedFormControl();
    searching: boolean;
    agencyUsers: any;

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private cdref: ChangeDetectorRef,
        private _dropdownsService: DropdownsService,
        public _translateService: TranslateService,
        private injector: Injector,
        private router: Router,

    ) {
        this.systemlang = this._translateService.currentLang;
    }

    ngOnInit(): void {
        this._translateService.onLangChange.subscribe(() => {
            this.systemlang = this._translateService.currentLang;
        });
        if (!this.form) {
            this._ownersCreateComponent = this.injector.get(
                OwnersCreateComponent
            ) as OwnersCreateComponent;
            this.form = this._ownersCreateComponent.form;
        }
        if (isEmpty(this.form.get('type').value)) {
            this.form.get('type').setValue('individual');
        }

        this.partners = this.form.get('partners') as UntypedFormArray;
        if (this.partners.length === 0) {
            this.partners.push(this.createPartners());
        }

        this._dropdownsService.getNationalities().subscribe((data: any) => {
            this.countries = data.body;
        });

        this._dropdownsService.getClassification('', this.currentRoute).subscribe((data: any) => {
            this.classifications = data;
        });

        if (!this.form.get('date_of_birth').value) {
            this.form.controls['birthday_greetings'].disable();
        }

        merge(this.linkedUsersSearch.valueChanges, this.form.get('linked_users').valueChanges)
        .pipe(startWith(''), debounceTime(300),distinctUntilChanged(),
            tap(() => this.searching = true),
            switchMap(() => {
                let search = this.linkedUsersSearch.value ? this.linkedUsersSearch.value : '';
                return this._dropdownsService.getUsersByAgencies(search, "");
            })
        )
        .subscribe((data: any) => {
            this.searching = false;
            this.agencyUsers = data.body;
        });

        this.form.get('date_of_birth').valueChanges.subscribe(() => {
            if (this.form.get('date_of_birth').value) {
                this.form.controls['birthday_greetings'].enable();
            }
            this.form
                .get('age')
                .setValue(
                    this.calculateAge(this.form.get('date_of_birth').value)
                );
        });
    }

    calAge(index: any): void {
        this.form
            .get('partners.' + index + '.age')
            .setValue(
                this.calculateAge(
                    this.form.get('partners.' + index + '.date_of_birth').value
                )
            );
    }

    ngAfterViewChecked(): void {
        this.cdref.detectChanges();
    }

    createPartners(): UntypedFormGroup {
        return this._formBuilder.group({
            title: { value: '', disabled: false },
            forename: { value: '', disabled: false },
            surname: { value: '', disabled: false },
            date_of_birth: { value: '', disabled: false },
            birthday_greetings: { value: '', disabled: false },
            age: { value: '', disabled: true },
            civil_status: { value: '', disabled: false },
            nationality: { value: '', disabled: false },
            document_type: { value: '', disabled: false },
            document_number: { value: '', disabled: false },
            document_type_two: { value: '', disabled: false },
            document_number_two: { value: '', disabled: false },
            gender: { value: '', disabled: false },
            phone: { value: '', disabled: false },
            email: { value: '', disabled: false },
            children: { value: '', disabled: false },
        });
    }

    calculateAge(dateOfBirth: any): any {
        if (typeof dateOfBirth !== 'string') {
            const timeDiff = Date.now() - dateOfBirth;
            const age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365);
            return age;
        } else {
            const timeDiff = Date.now() - new Date(dateOfBirth).getTime();
            const age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365);
            return age;
        }
    }

    CalcPartnerAge(index): void {
        this.form
            .get('partners.' + index + '.age')
            .setValue(
                this.calculateAge(
                    this.form.get('partners.' + index + '.date_of_birth').value
                )
            );
    }

    onChangetitle(): void {
        const title = this.form.get('title').value;
        if (title === 'Mr.') {
            this.form.get('gender').setValue('Male');
        }
        if (title === 'Ms.' || title === 'Mrs.' || title === 'Miss.') {
            this.form.get('gender').setValue('Female');
        }
    }

    onChangePartnertitle(index: any): void {
        const title = this.form.get(`partners.${index}.title`).value;
        if (title === 'Mr.') {
            this.form.get(`partners.${index}.gender`).setValue('Male');
        }
        if (title === 'Ms.' || title === 'Mrs.' || title === 'Miss.') {
            this.form.get(`partners.${index}.gender`).setValue('Female');
        }
    }
}
